<template>
  <div class="contact-widget" :class="{ 'contact-widget_raised': raised }">
    <transition name="contact-widget-pop">
      <div
        v-if="open"
        id="contact-widget-panel"
        class="contact-widget__panel"
        role="dialog"
        :aria-label="$dictionary.contactUs"
      >
        <div class="contact-widget__head">
          <span class="contact-widget__title">{{ $dictionary.contactUs }}</span>
          <button
            type="button"
            class="contact-widget__close"
            :aria-label="$dictionary.contactClose"
            @click="open = false"
          >
            <i class="el-icon-close" />
          </button>
        </div>

        <p class="contact-widget__label">{{ $dictionary.contactAnyQuestions }}</p>
        <a class="contact-widget__link" :href="`mailto:${email}`">
          <span class="contact-widget__icon"><i class="el-icon-message" /></span>
          <span>{{ email }}</span>
        </a>
        <a class="contact-widget__link" :href="telegramUrl(support)" target="_blank" rel="noopener">
          <span class="contact-widget__icon contact-widget__icon_tg">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.4 4.2 2.9 11.3c-1.3.5-1.2 1.2-.2 1.5l4.7 1.5 1.8 5.6c.2.6.4.8.9.8.4 0 .6-.2.9-.4l2.3-2.2 4.7 3.5c.9.5 1.5.2 1.7-.8l3.1-14.5c.3-1.3-.5-1.9-1.4-1.5Zm-3.5 3.4-8.7 7.9-.3 3.6-1.7-5.2 10-6.3c.5-.3.9-.1.7 0Z" /></svg>
          </span>
          <span>@{{ support }}</span>
        </a>

        <p class="contact-widget__label">{{ $dictionary.contactPartnership }}</p>
        <a class="contact-widget__link" :href="telegramUrl(partnership)" target="_blank" rel="noopener">
          <span class="contact-widget__icon contact-widget__icon_tg">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.4 4.2 2.9 11.3c-1.3.5-1.2 1.2-.2 1.5l4.7 1.5 1.8 5.6c.2.6.4.8.9.8.4 0 .6-.2.9-.4l2.3-2.2 4.7 3.5c.9.5 1.5.2 1.7-.8l3.1-14.5c.3-1.3-.5-1.9-1.4-1.5Zm-3.5 3.4-8.7 7.9-.3 3.6-1.7-5.2 10-6.3c.5-.3.9-.1.7 0Z" /></svg>
          </span>
          <span>@{{ partnership }}</span>
        </a>
      </div>
    </transition>

    <button
      type="button"
      class="contact-widget__toggle"
      :aria-expanded="open ? 'true' : 'false'"
      aria-controls="contact-widget-panel"
      @click="open = !open"
    >
      <i :class="open ? 'el-icon-close' : 'el-icon-chat-dot-round'" />
      <span>{{ $dictionary.contactUs }}</span>
    </button>
  </div>
</template>

<script>
// Плашка «Связаться с нами» в правом нижнем углу (вместо JivoChat): почта и Telegram поддержки,
// отдельно — Telegram по вопросам сотрудничества
export default {
  name: 'ContactWidget',
  props: {
    // Над плашкой cookie, пока она показана
    raised: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      open: false,
      email: '911@hodlbase.org',
      support: 'hodlbase_support',
      partnership: 'HODLBASECLUB'
    }
  },
  watch: {
    open (value) {
      if (value) {
        document.addEventListener('click', this.onOutsideClick, true)
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.removeListeners()
      }
    }
  },
  beforeDestroy () {
    this.removeListeners()
  },
  methods: {
    telegramUrl (username) {
      return `https://t.me/${username}`
    },
    onOutsideClick (event) {
      if (!this.$el.contains(event.target)) this.open = false
    },
    onKeydown (event) {
      if (event.key === 'Escape') this.open = false
    },
    removeListeners () {
      document.removeEventListener('click', this.onOutsideClick, true)
      document.removeEventListener('keydown', this.onKeydown)
    }
  }
}
</script>

<style lang="stylus" scoped>
.contact-widget
  --cw-accent: #6c4ee0
  --cw-accent-hover: #5a3dcc
  --cw-surface: #ffffff
  --cw-text: #1d1a2b
  --cw-muted: #6b6780
  --cw-border: rgba(108, 78, 224, 0.14)
  --cw-hover: rgba(108, 78, 224, 0.07)
  position fixed
  right 20px
  bottom 20px
  z-index 2000
  display flex
  flex-direction column
  align-items flex-end
  gap 12px
  transition bottom 0.3s ease

.contact-widget_raised
  bottom 92px

html[data-theme="dark"] .contact-widget
  --cw-accent: #8b72ff
  --cw-accent-hover: #9d87ff
  --cw-surface: #1d2025
  --cw-text: #e7e9ec
  --cw-muted: #a3a9b3
  --cw-border: #383e47
  --cw-hover: rgba(157, 135, 255, 0.1)

.contact-widget__toggle
  display inline-flex
  align-items center
  gap 8px
  height 46px
  padding 0 20px
  border none
  border-radius 23px
  background var(--cw-accent)
  color #ffffff
  font inherit
  font-size 15px
  font-weight 600
  white-space nowrap
  cursor pointer
  box-shadow 0 10px 28px rgba(76, 52, 170, 0.32)
  transition background 0.2s ease, transform 0.15s ease
  i
    font-size 18px
  &:hover
    background var(--cw-accent-hover)
  &:active
    transform translateY(1px)
  &:focus-visible
    outline 2px solid var(--cw-accent)
    outline-offset 3px

.contact-widget__panel
  width 290px
  padding 16px 16px 12px
  background var(--cw-surface)
  border 1px solid var(--cw-border)
  border-radius 16px
  box-shadow 0 18px 50px rgba(30, 20, 80, 0.18)
  color var(--cw-text)

.contact-widget__head
  display flex
  align-items center
  justify-content space-between
  margin-bottom 4px

.contact-widget__title
  font-size 16px
  font-weight 700

.contact-widget__close
  display inline-flex
  align-items center
  justify-content center
  width 28px
  height 28px
  border none
  border-radius 8px
  background transparent
  color var(--cw-muted)
  cursor pointer
  &:hover
    background var(--cw-hover)
    color var(--cw-text)

.contact-widget__label
  margin 12px 0 6px
  font-size 13px
  color var(--cw-muted)

.contact-widget__link
  display flex
  align-items center
  gap 10px
  padding 8px
  margin 0 -8px
  border-radius 10px
  color var(--cw-text)
  font-size 15px
  font-weight 500
  text-decoration none
  word-break break-all
  &:hover
    background var(--cw-hover)
    color var(--cw-accent)

.contact-widget__icon
  flex-shrink 0
  display inline-flex
  align-items center
  justify-content center
  width 32px
  height 32px
  border-radius 50%
  background var(--cw-hover)
  color var(--cw-accent)
  font-size 16px
  svg
    width 17px
    height 17px
    fill currentColor

.contact-widget__icon_tg
  background #229ed9
  color #ffffff

@media (max-width: 767px)
  .contact-widget
    right 12px
    bottom 12px
  .contact-widget_raised
    bottom 84px
  .contact-widget__toggle
    height 42px
    padding 0 16px
    font-size 14px
  .contact-widget__panel
    width calc(100vw - 24px)
    max-width 320px

.contact-widget-pop-enter-active, .contact-widget-pop-leave-active
  transition opacity 0.2s ease, transform 0.2s ease
  transform-origin bottom right
.contact-widget-pop-enter, .contact-widget-pop-leave-to
  opacity 0
  transform translateY(8px) scale(0.97)

@media (prefers-reduced-motion: reduce)
  .contact-widget, .contact-widget__toggle, .contact-widget-pop-enter-active, .contact-widget-pop-leave-active
    transition none
</style>
